import Component from 'Component';
import Airport from './geo/Airport';
import Location from './geo/Location';

export default class Geo extends Component {

  _namespace = this.constructor.name;

  _components = [
    new Airport(this.App, this._namespace),
    new Location(this.App, this._namespace)
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}